export default (entities, valueKey, labelKey, filterUndefinedValues = true) => entities.map(entity => ({
  value: entity[valueKey],
  label: entity[labelKey]
})).filter(item => filterUndefinedValues ? item.value !== undefined : true);
